<template>
  <div style="text-align: center">
    <h1 style="margin: 20px">图库</h1>
    <div style="width: 85%;margin: auto">
      <img v-for="(i,index) in imagesData" v-lazy="i.url" :key="i.id" width="300px" style="margin: 10px" @click="clickImage(i.id)">
    </div>
    <Page ref="pages" :total=total :page-size="30" @on-change="pageClick"/>
  </div>
</template>

<script>
  import {ajaxFetch} from '../utils'
  export default {
    name: 'ImagePage',
    data () {
      return {
        total: 0,
        imagesData:[],
      }
    },
    mounted: function () {
      this.name = this.$route.query.name
      this.typeId = this.$route.query.id
      this.listByImagePage(0)
    },
    methods: {
      listByImagePage: function (current) {
        ajaxFetch('post','/client/productTable/imagePage',{current:current,size:30},(response) => {
          if (response.code === 200) {
            this.imagesData = response.data.data
            this.total = parseInt(response.data.total)
          } else {

          }
        }, (err) => {
          console.log(err)
        } )
      },
      pageClick: function(page) {
        this.listByImagePage(page)
      },
      clickImage: function (id) {
        this.$router.push({name: 'detailImgPage', query: {id: id}})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ImagePage.vue